export default {"src":"/_next/static/media/RFX_ICON.339c1494.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};